<!--
  Semantics: an <aside> (complementary landmark) with an accessible name, so it
  is reachable by landmark navigation and readable in document order. It is
  deliberately NOT role="alert" or role="status" — those announce by themselves,
  and the .cse-sr-only polite region below is already the announcement channel
  used everywhere else on this branch (case-detail, notebook-cards, editnote).
  Two live sources would announce the same sentence twice.
-->
<aside class="tzw" *ngIf="visible" aria-label="Time zone notice">
  <div class="tzw-ico" aria-hidden="true"><i class="fa-solid fa-triangle-exclamation"></i></div>

  <div class="tzw-body">
    <div class="tzw-t">{{ title }}</div>
    <div class="tzw-d">{{ body }}</div>
  </div>

  <button type="button" class="tzw-cta" *ngIf="canOpenSettings" (click)="openTimeZoneSetting()">
    Set time zone
  </button>

  <button type="button" class="tzw-x" *ngIf="dismissible" (click)="dismiss()"
    aria-label="Dismiss the time zone notice for this session">
    <i class="fa-solid fa-xmark" aria-hidden="true"></i>
  </button>
</aside>

<!-- Shared live-region pattern (.cse-sr-only + aria-live), not a second one. -->
<div class="cse-sr-only" aria-live="polite" aria-atomic="true">{{ liveMessage }}</div>
